import { FloatFooter } from '~/components/float/FloatFooter'
import { useReservable } from '~/features/guide/hooks/reservable'
import type { RestaurantId } from '~/lib/graphql/scalars'

type Props = {
  supportsInventoryNotification: boolean
  restaurantId: RestaurantId
}

export function GuideFooter({ supportsInventoryNotification, restaurantId }: Props) {
  const reservable = useReservable(restaurantId)
  return (
    <FloatFooter
      restaurantId={restaurantId}
      reservable={reservable}
      supportsInventoryNotification={supportsInventoryNotification}
    />
  )
}
